<div class="modal-container" role="dialog" aria-labelledby="large-image-navigator-h2"
  data-automation-id="large-image-navigator-dialog">
  <rdrx-modal-header (closeEvent)="dialogRef.close()">
    <h2 class="modal-header" id="large-image-navigator-h2">{{ 'large_image_navigator' | translate }}</h2>
  </rdrx-modal-header>

  <mhe-large-image-navigator class="lin" [src]="src" [alt]="alt"
    [credit]="credit"></mhe-large-image-navigator>
</div>
